import classic from 'ember-classic-decorator';

import ApplicationSerializer from './application';

@classic
export default class LinkinbioBlockSerializer extends ApplicationSerializer {
  attrs = {
    linkinbioAttachments: {
      key: 'linkinbio_attachments',
      embedded: 'always',
      serialize: 'records'
    },
    linkinbioTags: {
      key: 'linkinbio_tags',
      embedded: 'always',
      serialize: 'records'
    }
  };
}
